<template>
  <div
    role="alert"
    class="
      px-5
      py-4
      mt-6
      flex
      items-center
      justify-between
      font-normal
      text-sm text-gray-900
      rounded-lg
      shadow
      bg-vice-rose-50
      border-2 border-red-300
    "
  >
    <div class="inline-flex ms-3 items-center gap-4">
      <span class="bg-vice-rose-400 w-4 h-4 rounded-full" />
      <div class="flex flex-col gap-1">
        <span class="font-semibold text-black">Session is ready to join</span>
        <p class="text-gray-500">
          <span>{{ session.title }}</span>
          -
          <span>{{ session.details.clinician.name }}</span>
        </p>
      </div>
    </div>

    <!-- Join session button -->
    <div class="flex flex-col">
      <ViceButton
        :href="route('session.show', session.unique_id)"
        data-cy="enter-course"
        @click="console.log(route('session.show', session.unique_id))"
        class="w-full bg-vice-teal-600"
        mediumRed
        medium
      >
        <span class="text-white font-semibold">Join session</span>
        <ExternalLinkIcon class="w-4 h-4" />
      </ViceButton>
    </div>
  </div>
</template>
<script>
import { ExternalLinkIcon } from '@heroicons/vue/outline';
import ViceButton from '@/Components/Buttons/ViceButton.vue';

export default {
  name: 'SessionIsReadyToJoinAlert',
  props: {
    session: {
      type: Object,
      required: true,
    },
  },
  components: {
    ExternalLinkIcon,
    ViceButton,
  },
};
</script>

<style scoped></style>
